import React from 'react';
import { Checkbox } from '../ui/checkbox';
import { Label } from '../ui/label';

// Generic reusable step renderer for all IAM maturity questions
export default function StepQuestion({ questions, answers, onChange }) {
  const handleRadio = (qId, value) => {
    onChange({ ...answers, [qId]: value });
  };

  const handleCheckbox = (qId, value, checked) => {
    const current = answers[qId] || [];
    // Selecting "aucune" deselects everything else; selecting anything else deselects "aucune"
    let next;
    if (value === 'aucune') {
      next = checked ? ['aucune'] : [];
    } else {
      const without = current.filter(v => v !== 'aucune');
      next = checked ? [...without, value] : without.filter(v => v !== value);
    }
    onChange({ ...answers, [qId]: next });
  };

  return (
    <div className="space-y-8">
      {questions.map((q) => (
        <div key={q.id}>
          <p className="text-base font-semibold mb-4 leading-snug">{q.label}</p>

          {q.type === 'radio' && (
            <div className="space-y-3">
              {q.options.map((opt) => {
                const selected = answers[q.id] === opt.value;
                return (
                  <button
                    key={opt.value}
                    type="button"
                    onClick={() => handleRadio(q.id, opt.value)}
                    className={`w-full text-left px-4 py-3 rounded-xl border transition-all duration-200 flex items-center gap-3 ${
                      selected
                        ? 'border-primary bg-primary/10 text-foreground'
                        : 'border-border bg-card/30 text-muted-foreground hover:border-primary/50 hover:bg-muted/30'
                    }`}
                  >
                    <span className={`w-4 h-4 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${
                      selected ? 'border-primary bg-primary' : 'border-muted-foreground'
                    }`}>
                      {selected && <span className="w-2 h-2 rounded-full bg-white" />}
                    </span>
                    <span className="text-sm font-medium">{opt.label}</span>
                  </button>
                );
              })}
            </div>
          )}

          {q.type === 'checkbox' && (
            <div className="space-y-3">
              {q.options.map((opt) => {
                const checked = (answers[q.id] || []).includes(opt.value);
                return (
                  <button
                    key={opt.value}
                    type="button"
                    onClick={() => handleCheckbox(q.id, opt.value, !checked)}
                    className={`w-full text-left px-4 py-3 rounded-xl border transition-all duration-200 flex items-center gap-3 ${
                      checked
                        ? 'border-primary bg-primary/10 text-foreground'
                        : 'border-border bg-card/30 text-muted-foreground hover:border-primary/50 hover:bg-muted/30'
                    }`}
                  >
                    <span className={`w-4 h-4 rounded-md border-2 flex-shrink-0 flex items-center justify-center ${
                      checked ? 'border-primary bg-primary' : 'border-muted-foreground'
                    }`}>
                      {checked && (
                        <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 12 12">
                          <path d="M2 6l3 3 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      )}
                    </span>
                    <span className="text-sm font-medium">{opt.label}</span>
                  </button>
                );
              })}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
